<template>
    <div class="page page-product" :style="{'backgroundImage': (!$root.isMobile)?'url('+bg+')':''}">
        <productSlider :bg="bg"/>
    </div>
</template>

<script>
    import productSlider from './productSlider';

    export default {
        name: 'ProductBase',
        props: ['bg'],
        components: {
            productSlider
        }
    }
</script>



// WEBPACK FOOTER //
// productBase.vue?009f90f0